import React, { useEffect } from "react";
import "./about.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../Footer/Footer";
function About() {
  
  useEffect(() => {
    window.scrollTo({
      behavior:"smooth",
      top:0
    })
    AOS.init({ duration: 1000 });
  },[])
  return (
    <>
    <div className="about" data-aos="flip-left">
      <h2>أهلاً وسهلاً بكم في مؤسسة كنفاني للسياحة والسفر</h2>
      <h2>Jaramana. albaladya , Jaramana, Syria</h2>
      <h2>خدماتنا متعددة</h2>
      <h2>وفيكن منكبر</h2>
      <h2>بعتولنا طلبكن ورح نلبيكن بأقرب فرصة ممكنة</h2>
      <ul>
      <li>تذاكر الطيران</li>
      <li>فيز سياحية</li>
      <li>حجوزات فندقية</li>
      <li>تأمين صحي</li>
      <li>نقل برا إلى لبنان</li>
      <li>قبولات جامعية</li>
      </ul>

    </div>
    <Footer/>
    </>
  );
}

export default About;
